import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchApi from './fetchApi';

interface CreateBookingVariables {
  from?: Date;
  to?: Date;
  organizerId?: number;
  roomId?: number;
  bookingLabel?: string;
}

interface CreateBookingResponse {
  status: 'ok';
  booking_id: number;
  booking: Odoo.Booking;
}

const useCreateBookingMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationKey: ['create-booking'],
    mutationFn: (data: CreateBookingVariables) =>
      fetchApi<CreateBookingResponse>('/api/bookings', {
        method: 'POST',
        body: JSON.stringify({
          from: data.from?.toISOString(),
          to: data.to?.toISOString(),
          organizer_id: String(data.organizerId),
          room_id: String(data.roomId),
          booking_label: data.bookingLabel,
        }),
      }),
    onSuccess: (result: CreateBookingResponse) => {
      client.setQueriesData<Odoo.Booking[]>({ queryKey: ['bookings'] }, oldData => {
        if (!oldData) return [result.booking];
        return [...oldData, result.booking];
      });
    },
  });
};

export default useCreateBookingMutation;
